/**
 * 客製化 useFetch
 *
 * @returns useFetch
 */

import type { UseFetchOptions } from 'nuxt/app';

export function useCustomFetch<T>(
  url: string | (() => string),
  options: UseFetchOptions<T> = {}
) {
  const { $customFetch } = useNuxtApp();
  return useFetch(url, {
    ...options,
    $fetch: $customFetch,
  });
}
